module.exports = __webpack_public_path__ + "img/Oval-white.bdc43e07.svg";